// File: frontend/src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { toast, Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import './LoginPage.css'; // Re-using the same CSS for a consistent look

function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [messageSent, setMessageSent] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // This is the Supabase function
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/update-password`, // Where to send the user after they click the link
      });
      
      if (error) throw error;
      
      toast.success('Password reset link sent! Please check your email.');
      setMessageSent(true); // Show a success message on the page
      
    } catch (error) {
      toast.error(error.error_description || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="login-box">
        <img src="/logo_fullmockup.png" alt="FullMockup.com Logo" className="login-logo" />

        {messageSent ? (
          // --- 1. SUCCESS STATE ---
          <div className="forgot-password-success">
            <h2>Check your email</h2>
            <p>
              A password reset link has been sent to <strong>{email}</strong>.
            </p>
            <p>
              Please check your inbox (and spam folder) to set your new password.
            </p>
            <Link to="/login" className="login-button email-button" style={{marginTop: '1.5rem', textDecoration: 'none'}}>
              Back to Login
            </Link>
          </div>

        ) : (
          // --- 2. DEFAULT STATE ---
          <>
            <h2 className="forgot-password-title">Forgot Your Password?</h2>
            <p className="forgot-password-subtitle">
              No problem. Enter your email address and we'll send you a link to reset it.
            </p>

            <form onSubmit={handlePasswordReset}>
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button 
                className="login-button email-button" 
                type="submit" 
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-small"></div>
                ) : (
                  'Send Reset Link'
                )}
              </button>
            </form>

            <div className="auth-toggle">
              <p>
                Remembered your password?{' '}
                <Link to="/login" style={{color: 'var(--color-secondary)', fontWeight: 600}}>
                  Sign In
                </Link>
              </p>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default ForgotPasswordPage;